import { FC } from 'react';

import { DangerousHTML, Modal, Typography, Image, ButtonSizes, LinkAsButton, Icon } from '@/shared/ui';

import { UserServiceExternal } from '@/api/types';

import './ExternalServiceDetailsModal.scss';

interface ServiceDetailsModalProps {
  service: UserServiceExternal;
  onClose: () => void;
}

export const ExternalServiceDetailsModal: FC<ServiceDetailsModalProps> = ({ service, onClose }) => {
  const { name, short_description, description, icon, link } = service;
  return (
    <Modal
      title={<Image src={icon} fallback="/images/icons-set.svg" alt={name} />}
      open={!!service}
      onCancel={onClose}
      classNames={{
        content: 'service_details',
        body: 'service_details__modal-body',
        footer: 'service_details__modal-footer',
        header: 'service_details__modal-header',
      }}
      footer={
        <LinkAsButton size={ButtonSizes.MD} to={link} onClick={onClose}>
          Перейти <Icon name="go_out" />
        </LinkAsButton>
      }
    >
      <div className="service-details-modal__title">
        <Typography variant="H2">{name}</Typography>
        {short_description && <Typography>{short_description}</Typography>}
      </div>
      <DangerousHTML className="service-details-modal__content" content={description} />
    </Modal>
  );
};
